var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoThin = function SvgVideoThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.988 5.082A2.488 2.488 0 0 0 1.5 7.57v8.965a2.49 2.49 0 0 0 2.488 2.488H13.782a2.488 2.488 0 0 0 2.488-2.488v-1.16l3.347 2.668c.76.606 1.883.065 1.883-.907V6.823c0-.972-1.123-1.513-1.883-.908l-3.338 2.66-.008-1.026a2.486 2.486 0 0 0-2.488-2.467H3.988ZM2.16 7.57c0-1.01.819-1.828 1.828-1.828h9.795A1.829 1.829 0 0 1 15.61 7.57v5.3l-.001.013v3.652c0 1.01-.818 1.828-1.828 1.828H3.988a1.828 1.828 0 0 1-1.828-1.828V7.57ZM20.03 6.431a.5.5 0 0 1 .811.391v10.314a.5.5 0 0 1-.811.391l-3.759-2.995V9.426l3.759-2.995Z"
  })));
};
export default SvgVideoThin;